export default __webpack_public_path__ + "static/media/cfx-riu-3.2021d02c.png";